import { Component, ChangeDetectorRef, Input, OnInit } from '@angular/core';
import { NewRelicService } from '../../../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { FormGroup, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { distinctUntilChanged, first } from 'rxjs/operators';
import { clone, compact, find, findIndex, flatten, forEach, isArray, get, uniq } from 'lodash';

// Models
import { QuestionBase } from 'src/app/models/question-base';
import { customFormTypes } from 'src/app/models/data-model';
import { optionsMap } from 'src/app/models/options-map';

// Store
import { Store } from '@ngrx/store';
import { AppState } from '../app-reducer';

// Modal
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../../../../../src/app/components/modal.component';
import { AppConstants } from '../app.constants';
import { CommonService } from '../services/common.service';

// Services
import { ProcessorService } from '../services/processor.service';
import { NavigationService } from '../services/navigation.service';
import { QuestionService } from '../services/question.service';
import { QuestionControlService } from '../services/question-control.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-question',
  templateUrl: './dynamic-form-question.component.html'
})

export class DynamicFormQuestionComponent implements OnInit {
  mask: any = null;
  maxInputLength = '100';
  optionsMap: any;
  questions: any;
  isSSN: boolean = false;
  ssnType: any = 'password';
  appState$: Observable<any>;
  medicalConditionQuestions = [];
  autoCompleteInputVal: string;
  isPercent: boolean = false;
  @Input() question: QuestionBase<any>;
  @Input() form: FormGroup;
  @Input() childQuestions: any;
  @Input() isEditable: boolean;
  @Input() multiIndex = '';
  @Input() enabledQuestions: any;
  @Input() toggleOpenFields: boolean;
  blockIndex: number = 1;
  isDemo = false;
  demoDisable = false;
  demoDisabled = false;
  hasCustomValidator: boolean;
  NIGOQuestion: boolean;
  disableMultipleReponseButton: boolean = false;
  AgentEmailAddress: any;
  appId: any;
  LTCDisclaimerShown:boolean = false;

  constructor(
    private newRelicService: NewRelicService,
    private qcs: QuestionControlService,
    public route: ActivatedRoute,
    private store: Store<AppState>,
    private processorService: ProcessorService,
    private navigationService: NavigationService,
    public questionService: QuestionService,
    private cdr: ChangeDetectorRef,
    public apiService: ApiService,
    private popup: MatDialog,
    private appConstants: AppConstants,
    private commonService: CommonService
  ) {
    // get questions from state
    this.appState$ = this.store.select('sections');
    const sectionData = this.route.snapshot.data.blockName;
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      this.appId = state.appId;
      if (state.questions) {
        this.questions = find(state.questions, { Name: sectionData }).Questions;
      }
      if (state.isDemo){
        this.isDemo = true;
      }

      // Log successful state retrieval
      this.newRelicService.addPageAction('State Retrieved', { status: 'success', appId: this.appId });
    }, (error) => {
      console.log('error', error);
      this.newRelicService.noticeError(error, { appId: this.appId });
    });
  }

  ngOnInit() {
    this.newRelicService.addPageAction('DynamicFormQuestionComponent ngOnInit', { status: 'initialized', appId: this.appId });

    // custom length
    if (this.question.QuestionName === 'IllustrationPrePop') {
      // this.form.controls[this.question.QuestionName].setValue('true');
      // this.cdr.detectChanges();
    } else if (this.question.QuestionType === 'Phone') {
      this.maxInputLength = '12';
      if (this.isDemo){
        this.form.controls[this.question.QuestionName].setValue('6175721000');
        this.form.controls[this.question.QuestionName].disable();
      }
    } else if (this.question.QuestionName === 'PurposeOfInsurance') {

      this.form.get("PurposeOfInsurance").valueChanges.subscribe(checkBoxValues => {

        const key = Object.keys(this.question.QuestionOptions).find(key => this.question.QuestionOptions[key].Name === 'LTC');

        let count = 0

        checkBoxValues.forEach(item => {
          count += item === true ? 1:0;
        });

        if(checkBoxValues[key] === true && this.LTCDisclaimerShown !== true && count === 1) {

          const modalRef = this.popup.open(ModalComponent, {
            disableClose: true,
            closeOnNavigation: true,
            data: {
              size: '',
              // Array of screens
              screens: [
                {
                  show: true,
                  exit_btn: true,
                  content: [
                    {
                      type: 'text',
                      content: 'The long-term care rider cannot be the sole purpose for the life insurance.' +
                               ' To avoid underwriting processing delays, please select a secondary purpose of insurance.',
                      class: this.appConstants.modalParagraphDefault
                    },
                    {
                      type: 'button_group',
                      buttons: [
                        {
                          type: 'button',
                          label: 'Acknowledge',
                          clickFunction: 'close',
                          class: this.appConstants.buttonPrimary
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          });

          modalRef.afterClosed().subscribe(checkResult => {
            this.LTCDisclaimerShown = true;
          });
        }
      });

    } else if (this.question.QuestionType === 'SSN' || this.question.QuestionName === 'BeneficiarySSN') {
      this.maxInputLength = '11';
      this.isSSN = true;
      if (this.isDemo){
        this.form.controls[this.question.QuestionName].setValue('123456789');
        this.form.controls[this.question.QuestionName].disable();
      }
    } else if (this.question.QuestionName === 'PolicyOwnerTaxId' || this.question.QuestionName === 'TrusteeEntityTaxID' || this.question.QuestionName === 'BeneficiaryTaxID' || this.question.QuestionName === 'TINEmployerID') {
      this.maxInputLength = '10';
      this.isSSN = true;
      if (this.isDemo){
        this.form.controls[this.question.QuestionName].setValue('123456789');
        this.form.controls[this.question.QuestionName].disable();
      }
    } else if (this.question.QuestionType === 'Date') {
      this.maxInputLength = '10';
    } else if (this.question.QuestionType === 'MonthYear') {
      this.maxInputLength = '7';
    } else if (this.question.Units === '%' && this.question.QuestionType === 'Integer') {
      this.maxInputLength = '3';
    } else if (this.question.Units === '%' && this.question.QuestionType === 'Decimal') {
      this.maxInputLength = '6';
    } else if (this.question.QuestionName === 'PendingTestTypeOther' || this.question.QuestionName === 'CompletedDiagnosticTestTypeOther') {
      this.maxInputLength = '200';
    }
      // email address
    else if (
      this.question.QuestionName.includes('Email')
      || this.question.QuestionText.includes('Email Address')
      || this.question.inputType === 'email'
    ) {
      this.maxInputLength = '200';

      if (this.isDemo){

        this.appState$.pipe(first()).subscribe((state: any) => {
          this.appId = state.appId;
          console.log('this.appId: ', this.appId);
        });

        const req = {
          'appId': this.appId
        };
        if (window['jhConfig'].email === ''){
          //console.log('jhconfig email not found');

          this.apiService.getAgentEmail(req).subscribe((resp) => {
            if (resp){
              //console.log('resp: ', resp);
              this.AgentEmailAddress = resp;
             //console.log('this.AgentEmailAddress: ', this.AgentEmailAddress);
              const agentEmailAddress = (window['jhConfig'].email !== '') ? window['jhConfig'].email : this.AgentEmailAddress;
              this.form.controls[this.question.QuestionName].setValue(agentEmailAddress);
              this.form.controls[this.question.QuestionName].disable();
            }
          });
        }else {
          //console.log('this.isam email found: ', window['jhConfig'].email);
          this.form.controls[this.question.QuestionName].setValue(window['jhConfig'].email);
          this.form.controls[this.question.QuestionName].disable();
        }
        this.demoDisabled = true;
      }
    } else if (get(optionsMap[this.question.QuestionName], 'length')) {
      this.maxInputLength = get(optionsMap[this.question.QuestionName], 'length');
    }

    if (this.question.QuestionName === 'MedicalConditionDetails') {
      this.addMedicalConditionsDetails(this.question);
    }

    if (this.question.QuestionName === 'BorrowRateWA' || this.question.QuestionName === 'MinimumInterestWA') {
      this.mask = this.questionService.activateMasks('mask-integer');
      this.isPercent = true;
    }

    // activate masks
    if (this.question.QuestionType === 'Date') {
      this.mask = this.questionService.activateMasks('mask-date');
    } else if (this.question.QuestionType === 'MonthYear') {
      this.mask = this.questionService.activateMasks('mask-date-short');
    } else if (isArray(this.question.mask) && this.question.mask.length > 0) {
      this.mask = this.questionService.activateMasks(this.question.mask[0], this.question.Units);
    }

    this.isEditable = this.isEditable == null ? true : this.isEditable;
    if (this.toggleOpenFields && this.enabledQuestions ? this.enabledQuestions.includes(this.question.QuestionName): false) {
      this.isEditable = true;
    }

    if (this.isDemo) {
      this.setDemoValues();
      //this.demoDisableQuestions();
    }

    // set a variable to trigger class that styles questions with validators other than 'required'
    if (this.form.controls[this.question.QuestionName] && this.form.controls[this.question.QuestionName]['_rawValidators'] && isArray(this.form.controls[this.question.QuestionName]['_rawValidators']) && this.form.controls[this.question.QuestionName]['_rawValidators'].length > 0) {
      // console.log('_rawValidators for', this.question.QuestionName, ':', this.form.controls[this.question.QuestionName]['_rawValidators']);
      const bool = this.form.controls[this.question.QuestionName]['_rawValidators'].some(item => item.name !== 'required');
      this.hasCustomValidator = bool ? true : false;
    }

    if (this.question.QuestionName.includes('NIGO')) {
      this.NIGOQuestion = true;
    }
  }

  ngAfterViewInit() {
    if (this.isDemo) {
      this.setDemoValues();
      this.demoDisableQuestions();
    }

    if (this.question.MultipleResponse) {
    // subscribe to observable used for disabling the "Next" button from child components
      this.navigationService.disableMultipleReponseButtonStatus().pipe(distinctUntilChanged()).subscribe((bool) => {
        this.disableMultipleReponseButton = bool;
        this.cdr.markForCheck();
      });
    }
    this.newRelicService.addPageAction('DynamicFormQuestionComponent ngAfterViewInit', { status: 'view initialized', appId: this.appId });

    }

  // detect checkbox change and reset if needed
  /**
   * checkboxChange - detect checkbox changes and reset if "None" option is selected
   * @param option - current option clicked
   * @param checkIndex - index of option
   * @param event - material design event
   */
  checkboxChange(option: { IsExclusive: boolean; }, checkIndex: number, event: { checked: boolean; }) {
    try {
      // current form value
      const checkboxFormValues = this.form.controls[this.question.QuestionName].value;

      // reset option index
      const resetIndex = findIndex(this.question.QuestionOptions, { IsExclusive: true });

      // init form control values
      let checkboxControlValues = [];

      // if 'None' option is changed
      // options with Reset property
      if (option.IsExclusive && event.checked) {
        // uncheck everything else
        checkboxControlValues = this.question.QuestionOptions.map((control: any, idx: number) => {
          return idx === checkIndex ? true : false;
        });
      } else {
        // uncheck 'None'
        checkboxFormValues[resetIndex] = false;
        checkboxControlValues = clone(checkboxFormValues);
      }

      // update form values
      this.form.controls[this.question.QuestionName].setValue(checkboxControlValues, { emitEvent: true });

      // Log checkbox change
      this.newRelicService.addPageAction('Checkbox Changed', { status: 'success', questionName: this.question.QuestionName, appId: this.appId });
    } catch (error) {
      console.log('error', error);
      this.newRelicService.noticeError(error, { appId: this.appId });
    }
  }

  addDetails(section: string) {
    try {
      const control = <FormArray>this.form.controls[this.question.QuestionName];
      control.push(this.qcs.toFormGroup(this.childQuestions, true));

      // Log details addition
      this.newRelicService.addPageAction('Details Added', { status: 'success', section, appId: this.appId });
    } catch (error) {
      console.log('error', error);
      this.newRelicService.noticeError(error, { appId: this.appId });
    }
  }

  removeDetails(index: number, section: any) {
    try {
      const control = <FormArray>this.form.controls[this.question.QuestionName];
      control.removeAt(index);

      // Log details removal
      this.newRelicService.addPageAction('Details Removed', { status: 'success', section, appId: this.appId });
    } catch (error) {
      console.log('error', error);
      this.newRelicService.noticeError(error, { appId: this.appId });
    }
  }

  showConditionalOption(clause: string, QuestionName?, idx?) {
    try {
      if (clause === '0') { return false };
      // detect if question is in child form (formarray/multipleresponse) and if so send both form values
      if (this.form.parent && this.form.parent.parent) {
        return this.processorService.showConditionalOption(clause, this.form.parent.parent.getRawValue(), this.form.getRawValue());
      } else {
        const conditionOpt = this.processorService.showConditionalOption(clause, this.form.getRawValue());

        // fix for illustration warning
        if (QuestionName === "PermRidersAndBenefits" && !conditionOpt) {
          // if conditional option is false, set the rider to false - for illustration warnings
          this.form.controls[QuestionName]['controls'][idx].setValue(false);
        }

        // Log conditional option check
        this.newRelicService.addPageAction('Conditional Option Checked', { status: 'success', clause, questionName: QuestionName, appId: this.appId });

        return conditionOpt;
      }
    } catch (error) {
      console.log('error', error);
      this.newRelicService.noticeError(error, { appId: this.appId });
    }
  }

  // check if multi response
  get isMultipleResponse() {
    return this.question.MultipleResponse && this.question.QuestionType === 'Compound';
  }

  // custom forms: types and multi response questions
  get showCustomForm() {
    const isCustomFormType = customFormTypes.includes(this.question.QuestionType) || this.isMultipleResponse || this.question.QuestionName === 'IULPremPaymentAllocation' || this.question.QuestionName === 'IULFixedAcctAlloc' || this.question.QuestionName === 'IULProceedsAllocToCompound'
      || this.question.QuestionName === 'VULFundAggressiveOptionsCompound' || this.question.QuestionName === 'VULFundGrowthOptionsCompound'
      || this.question.QuestionName === 'VULFundIncomeOptionsCompound' || this.question.QuestionName === 'VULFundGrowthIncomeOptionsCompound'
      || this.question.QuestionName === 'VULFundIndexedOptionsCompound' || this.question.QuestionName === 'VULFundLifestyleOptionsCompound' || this.question.QuestionName === 'VULFundETFOptionsCompound'
      || this.question.QuestionName === 'VULFundManagedVolatilityOptionsCompound' || this.question.QuestionName === 'VULFundConservativeOptionsCompound';
    return isCustomFormType;
  }

  // multi response 'ADD' label from optionsMap.ts
  get buttonLabel() {
    return get(optionsMap[this.question.QuestionName], 'multiResponseLabel') || null;
  }

  // update value from autocomplete selection
  updateValue(value: any, property: string) {
    const update = {};
    update[property] = value;
    this.form.patchValue(update);
  }

  addMedicalConditionsDetails(question) {
    let oldConditions = [];
    let conditions = [];

    // get questions from state
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {

      // get selected conditions and questions from Part2SECTIONCMedicalConditions
      const medCons = clone(state.content.Part2SECTIONCMedicalConditions);
      const medConSection = find(state.questions, { Name: 'Part2SECTIONCMedicalConditions' });
      const medConQuestions = medConSection.Questions;
      for (const key in medCons) {
        if (key !== 'Part2SECTIONCMedicalConditionsSubmitted' && medCons[key]) {
          const questionName = 'Part2SECTIONCMedicalConditions.' + key;
          const conditionNames = this.processorService.getCheckboxValues(questionName, medCons[key], medConQuestions);
          conditions.push(conditionNames);
        }
      }
      conditions = uniq(flatten(conditions));
      if (conditions.includes('NoneOfTheseApplyToMe')) {
        conditions.splice(conditions.indexOf('NoneOfTheseApplyToMe'), 1);
      }

      // copy MedicalConditionDetails responses from state, if available
      if (state.content.Part2SECTIONCMedicalConditions2) {
        oldConditions = state.content.Part2SECTIONCMedicalConditions2.MedicalConditionDetails;
      }

    });

    // build question list to build drawers
    let drawerQuestions = clone(this.questions);
    drawerQuestions.shift();
    // console.log('drawerQuestions', drawerQuestions);

    drawerQuestions = this.trimMedicalConditionsQuestions(conditions, drawerQuestions);

    forEach(drawerQuestions, q => {
      const parentQuestion = find(drawerQuestions, { QuestionName: q.ParentQuestionName });
      const parentIsMultpleResponse = parentQuestion ? parentQuestion.MultipleResponse : false;
      if (!parentIsMultpleResponse) {
        this.medicalConditionQuestions.push(q);
      }
    });
    // console.log('this.medicalConditionQuestions', this.medicalConditionQuestions);

    // build FormArray with first child based on question list above
    const subForm = <FormArray>this.form.controls['MedicalConditionDetails'];
    subForm.setControl(0, this.qcs.toMedicalConditionsFormGroup(this.medicalConditionQuestions));

    // list of questions retrieved from state
    const oldies = [];
    forEach(oldConditions, oldie => {
      oldies.push(oldie.ConditionName);
    });

    if (oldConditions.length > 0) {
      if (conditions.length >= oldConditions.length) {
        // add additional details for prepopulating if conditions list is changed or increased after saving details to state
        const toRemove = oldies.filter(x => !conditions.includes(x));
        const toAdd = conditions.filter(x => !oldies.includes(x));
        toRemove.slice().reverse().forEach(diff => {
          oldConditions.splice(oldies.indexOf(diff), 1);
        })
        toAdd.forEach(diff => {
          const addCondition = { ConditionName: diff };
          oldConditions.splice(conditions.indexOf(diff), 0, addCondition);
        })
      } else if (conditions.length < oldConditions.length) {
        // remove orphaned details and FormArray children if conditions list is reduced after saving details to state
        const difference = oldies.filter(x => !conditions.includes(x)).concat(conditions.filter(x => !oldies.includes(x)));
        difference.slice().reverse().forEach(diff => {
          oldConditions.splice(oldies.indexOf(diff), 1);
          subForm.removeAt(oldies.indexOf(diff));
        })
      }
    }

    forEach(conditions, (val, index) => {
      if (conditions.length >= oldConditions.length) {

        // add drawers for selected conditions
        if (index > 0 && conditions.length > subForm.length) {
          subForm.insert(index, this.qcs.toMedicalConditionsFormGroup(this.medicalConditionQuestions));
        }

        // prepopulate ConditionName
        subForm.controls[conditions.indexOf(val)].get('ConditionName').patchValue(val, { onlySelf: false, emitEvent: false });

      }

    })

    // populate drawers with data from state
    if (oldConditions.length > 0) {

      forEach(oldConditions, (drawer, index) => {
        subForm.setControl(index, this.qcs.toMedicalConditionsFormGroup(this.medicalConditionQuestions, true, oldConditions[index]));
      });
      subForm.patchValue(oldConditions);
    }
  }

  trimMedicalConditionsQuestions(conditions, questions) {

    const orphans = [];
    for (let i = 0; i < questions.length; i++) {
      const {QuestionName, ConditionalClause, ChildQuestions} = questions[i];
      if (ConditionalClause) {
        // stringify ConditionalClause array to use in following string matches
        const ConditionalClauseAsString = JSON.stringify(ConditionalClause);
        // erase questions related to unselected conditions, and add their children (and their children) to the orphans array
        if (((ConditionalClauseAsString.includes('ConditionName ==') && !conditions.some(v => ConditionalClauseAsString.includes(v.toString())))) || ConditionalClause === '0') {
          if (ChildQuestions.length > 0) {
            forEach(ChildQuestions, o => {
              const oq = this.qcs.getQuestion(questions, o.QuestionName);
              if (oq.ChildQuestions.length > 0) {
                forEach(oq.ChildQuestions, p => {
                  orphans.push(p.QuestionName);
                });
              }
              orphans.push(o.QuestionName);
            });
          }
          questions[i] = null;
        }
      }
    };
    // erase every question listed in orphans
    for (let i = questions.length - 1; i >= 0; i--) {
      if (questions[i] != null) {
        const {QuestionName} = questions[i];
        if (orphans.includes(QuestionName)) {
          questions[i] = null;
        }
      }
    };
    return compact(questions);
  }

  getChildQuestions(question: any) {
    return this.qcs.getChildQuestions(question, this.questions);
  }

  setDemoValues() {
    const demoValuesList = {
      'DriversLicense' : 'true',
      'PaymentPlanOptions' : 'AllPremiumInclInitial',
      'BankAcctOwnerName' : 'Customer Name',
      'BankAcctOwnerRelationship' : 'Self',
      'BankName' : 'John Hancock Bank',
      'BankAcctOwnerType' : 'Individual',
      'BankAcctType' : 'Checking',
      'BankAcctNum' : '1234567891011',
      'BankAcctRoutingNum' : '123654789',
      'PolicyOwnerInsured': 'SoleOwner',
    }
    forEach(demoValuesList, (value, key) => {
      if (key == this.question.QuestionName) {
        //console.log('key is equals!: ', key)
        this.form.controls[this.question.QuestionName].setValue(value);
      }
    })
  }

  demoDisableQuestions() {
    const demoDisabledQuestionList = [
      "DriversLicense",
      "PersonalTelephoneNumber",
      "DriversLicenseNumber",
      "BankAcctOwnerName",
      "BankAcctOwnerRelationship",
      "BankName",
      "BankAcctOwnerType",
      "BankAcctType",
      "BankAcctNum",
      "BankAcctRoutingNum",
      "PaymentPlanOptions",
      'PolicyOwnerInsured'
    ];
    if (demoDisabledQuestionList.includes(this.question.QuestionName)) {
      //console.log('demo disabling: ', this.question.QuestionName);
      this.form.controls[this.question.QuestionName].disable();
    }
  }

}
